export type ManagementConfigurationConfig = {
  hash: string;
  relatedHash: string | null;
  hostname: string;
  lastChangeAt: number;
  lastCheckAt: number;
  reason: string;
  sn: string;
  status: 'saved' | 'noChange';
};

export type CompareManagementConfigurationConfig = Pick<
  ManagementConfigurationConfig,
  'hash' | 'lastChangeAt' | 'hostname' | 'sn'
>;

export const isCompareManagementConfigurationConfig = (
  config: unknown,
): config is CompareManagementConfigurationConfig => {
  if (typeof config !== 'object' || config === null) {
    return false;
  }

  return (
    'hash' in config &&
    typeof config.hash === 'string' &&
    'lastChangeAt' in config &&
    typeof config.lastChangeAt === 'number' &&
    'hostname' in config &&
    typeof config.hostname === 'string' &&
    'sn' in config &&
    typeof config.sn === 'string'
  );
};
